import {
  IconComfortRenovation16,
  IconFinanceArrowBoldDown16,
  IconFinancePieChart16,
  IconFinanceSale16,
  IconFunctionalCalendar16,
  IconMapPin16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IMapperProps {
  icon?: string | null;
}

// нужен полный список названий иконок на бэке, сейчас точно соответствует только первая, остальные по аналогии

export const Mapper = ({ icon }: IMapperProps) => {
  switch (icon) {
    case 'functional16Calendar':
      return <IconFunctionalCalendar16 color="accent-main-primary" />;

    case 'finance16ArrowBoldDown':
      return <IconFinanceArrowBoldDown16 color="accent-main-primary" />;

    case 'comfort16Renovation':
      return <IconComfortRenovation16 color="accent-main-primary" />;

    case 'finance16PieChart':
      return <IconFinancePieChart16 color="accent-main-primary" />;

    case 'map16Pin':
      return <IconMapPin16 color="accent-main-primary" />;

    case 'finance16Sale':
      return <IconFinanceSale16 color="accent-main-primary" />;

    default:
      return null;
  }
};
